<template>
  <div>
    <div
      :class="[
        'l-flex-grid--no-wrap',
        'l-flex-grid--v-center',
        'l-flex-grid--h-right',
        'u-grow',
        'u-p2'
      ]"
    >
        <el-button
          v-if="showBackButton"
          @click="$emit('back-button-click')"
          data-test="back-button"
          type="text"
          class="u-p0 u-mr1"
          data-element="previous-view"
        >
          <fa-icon
            size="sm"
            icon="chevron-left"
          />
        </el-button>
        <strong class="u-text--lg u-brand-dark u-mr-auto u-ml2">
          Notes
        </strong>
        <div
          :class="[
            'l-flex-grid--no-wrap',
            'l-flex-grid--v-center',
            'l-flex-grid--h-right'
          ]"
        >

          <notes-reading-mode-toggle
            v-if="showReadingModeToggle"
            v-model="notesReadingMode"
          />

          <el-button
            v-if="showAddNoteButton"
            @click="$emit('add-note-click')"
            v-test-id="'show-composer-button'"
            class="u-ml2 u-p2"
            type="primary"
            data-element="add-note"
            :disabled="addNoteDisabled"
          >
              Add note
          </el-button>
          <div class="u-ml2">
             <slot name="notepad-header" />
          </div>
        </div>
    </div>
    <hr class="u-m0">
    <div
      v-if="showSearchAndFilterToolbar"
    >
      <div
        :class="[
          'u-p2',
          'l-flex-grid--no-wrap',
          'l-flex-grid--v-center',
          'l-flex-grid--h-right'
        ]">

        <notes-search-input
          @search-updated="$emit('search-updated')"
          class="u-mr2"
        />

        <notes-filter-popover
          @filters-updated="$emit('filters-updated')"
          :custom-filter-form="customFilterForm"
        >
          <template #filter-form="props">
            <slot
              name="filter-form"
              v-bind="props"
            />
          </template>
        </notes-filter-popover>

      </div>
      <notes-filter-tag-list />
      <hr class="u-m0" >
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import NotesSearchInput from '#/notes/components/NotesSearchInput'
import NotesFilterTagList from '#/notes/components/NotesFilterTagList'
import NotesFilterPopover from '#/notes/components/NotesFilterPopover'
import NotesReadingModeToggle from '#/notes/components/NotesReadingModeToggle'
import notesMutations from '#/notes/store/mutationTypes'

export default {
  name: 'NotepadHeader',
  props: {
    showReadingModeToggle: {
      type: Boolean,
      default: false
    },
    showAddNoteButton: {
      type: Boolean,
      default: false
    },
    showSearchAndFilterToolbar: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    customFilterForm: {
      type: Object,
      default: () => ({})
    },
    addNoteDisabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NotesSearchInput,
    NotesFilterTagList,
    NotesFilterPopover,
    NotesReadingModeToggle
  },
  computed: {
    ...mapState('notes', [
      'readingMode'
    ]),
    notesReadingMode: {
      get () {
        return this.readingMode
      },
      set (value) {
        this.setReadingMode(value)
      }
    }
  },
  methods: {
    ...mapMutations({
      setReadingMode: notesMutations.SET_READING_MODE
    })
  }
}
</script>
